jQuery(function($) {
    $( document ).ready(function() {

        gsap.registerPlugin(ScrollTrigger);
        var blocks = document.querySelectorAll('.animation-single-post');
        if(window.innerWidth > 767) {

            blocks.forEach(function(block) {
        
                var swiper = block.querySelector('.swiper-main');
                var swiperMainTitle = swiper.querySelector('#slider-main-title');
                var ShowAllSlidesBtn = swiper.querySelector('#show-all-slides');
                var images = swiper.querySelectorAll('img');
        
                images.forEach(function(img) {

                    let imgHeight = img.naturalHeight;
                    let imgWidth = img.naturalWidth;

                    // console.log('hauteur : ' ,imgHeight);
                    // console.log('width:' ,imgWidth);

                    if(imgHeight > imgWidth) {
                        img.classList.add('vertical');
                        gsap.to(img, {
                            height: '15vh',
                            scrollTrigger: {
                                trigger: block,
                                start: "top top",
                                ease: "none",
                                end: "+=100%",
                                scrub: true,
                            }
                        });
                    } else {
                      
                        gsap.to(img, {
                            height: '15vh',
                            width: '20vh',
                            scrollTrigger: {
                                trigger: block,
                                start: "top top",
                                ease: "none",
                                end: "+=100%",
                                scrub: true,
                            }
                        });
                    }

                    
        
                  
                })
                gsap.to(swiperMainTitle, {
                    opacity: 0,
                    scrollTrigger: {
                        trigger: block,
                        start: "top top",
                        ease: "none",
                        end: "+=100%",
                        scrub: true,
                    }
                });
                gsap.to(ShowAllSlidesBtn, {
                    opacity: 0,
                    scrollTrigger: {
                        trigger: block,
                        start: "top top",
                        ease: "none",
                        end: "+=100%",
                        scrub: true,
                        onLeave: () => {
                            ShowAllSlidesBtn.style.display = "none";
                        },
                        onUpdate: () => {
                            ShowAllSlidesBtn.style.display = "block";
                        }
                     
                    }
                });

            });
        }
    });
});
